function show(li) {
	li.removeAttribute('hidden');
}

function hide(li) {
	li.setAttribute('hidden', '');
}

document.querySelectorAll('.r2c-category-pills__toggle').forEach(function (btn) {
	btn.addEventListener('click', function () {
		const expanded = btn.getAttribute('aria-expanded') === 'true';
		const next = !expanded;

		btn.setAttribute('aria-expanded', String(next));

		const list = document.getElementById(btn.getAttribute('aria-controls'));
		if (!list) {
			return;
		}

		list.querySelectorAll('li.is-overflow').forEach(function (li) {
			if (next) {
				show(li);
			} else {
				hide(li);
			}
		});

		const label = btn.querySelector('.r2c-category-pills__toggle-label');
		if (label) {
			label.textContent = next ? label.dataset.labelLess : label.dataset.labelMore;
		}
	});
});
